import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
  createCampaign, 
  updateCampaign, 
  createAssetGroup, 
  updateAssetGroup,
  clearError,
  setSelectedCampaign,
  setSelectedAssetGroup,
  CreateCampaignPayload,
  UpdateCampaignPayload,
  CreateAssetGroupPayload,
  UpdateAssetGroupPayload,
  Campaign,
  AssetGroup
} from '../redux/campaign/campaignSlice';
import { RootState } from '../redux';
import { AppDispatch } from '../redux';

export const useCampaignManagement = () => {
  const dispatch = useDispatch<AppDispatch>();
  
  const {
    campaigns,
    assetGroups,
    selectedCampaign,
    selectedAssetGroup,
    status,
    error,
    isLoading
  } = useSelector((state: RootState) => state.campaign);

  const handleCreateCampaign = useCallback(async (campaignData: CreateCampaignPayload) => {
    try {
      const result = await dispatch(createCampaign(campaignData)).unwrap();
      return result;
    } catch (error) {
      console.error('Failed to create campaign:', error);
      throw error;
    }
  }, [dispatch]);

  const handleUpdateCampaign = useCallback(async (campaignData: UpdateCampaignPayload) => {
    try {
      const result = await dispatch(updateCampaign(campaignData)).unwrap();
      return result;
    } catch (error) {
      console.error('Failed to update campaign:', error);
      throw error;
    }
  }, [dispatch]);

  const handleCreateAssetGroup = useCallback(async (assetGroupData: CreateAssetGroupPayload) => {
    try {
      const result = await dispatch(createAssetGroup(assetGroupData)).unwrap();
      return result;
    } catch (error) {
      console.error('Failed to create asset group:', error);
      throw error;
    }
  }, [dispatch]);

  const handleUpdateAssetGroup = useCallback(async (assetGroupData: UpdateAssetGroupPayload) => {
    try {
      const result = await dispatch(updateAssetGroup(assetGroupData)).unwrap();
      return result;
    } catch (error) {
      console.error('Failed to update asset group:', error);
      throw error;
    }
  }, [dispatch]);

  const handleClearError = useCallback(() => {
    dispatch(clearError());
  }, [dispatch]);

  const handleSetSelectedCampaign = useCallback((campaign: Campaign | null) => {
    dispatch(setSelectedCampaign(campaign));
  }, [dispatch]);

  const handleSetSelectedAssetGroup = useCallback((assetGroup: AssetGroup | null) => {
    dispatch(setSelectedAssetGroup(assetGroup));
  }, [dispatch]);

  return {
    // State
    campaigns,
    assetGroups,
    selectedCampaign,
    selectedAssetGroup,
    status,
    error,
    isLoading,
    
    // Actions
    createCampaign: handleCreateCampaign,
    updateCampaign: handleUpdateCampaign,
    createAssetGroup: handleCreateAssetGroup,
    updateAssetGroup: handleUpdateAssetGroup,
    clearError: handleClearError,
    setSelectedCampaign: handleSetSelectedCampaign,
    setSelectedAssetGroup: handleSetSelectedAssetGroup,
  };
}; 